import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import ActionButton from './ActionButton'
import DropdownActionMenu from './DropdownActionMenu'
import $ from 'jquery'

/**
 * @author makovchik.
 * @since 16.08.2018.
 */
export default class ActionsMenuButtons extends TemplateView {
    constructor({
        /**
         * actions: [{
         *  title: '', - title for action
         *  actionClick: ()= > {}, - some action
         *  extraClass: '', - css class to item in menu
         * }, {} ...]
         */
        actions = [],
    }){
        super()

        this.params = {
            actions,
        }
    }

    templateHtml() {
        return "<div class='actionButtonWrapper'>" +
               "  <div class='actionButton'>" +
               "    <div class='img'></div>" +
               "    <div class='action'><%-actionsTitle%></div>" +
               "  </div>" +
               "  <div class='buttonMenu'/>" +
               "</div>"
    }

    templateModel() {
        return {
            actionsTitle: messageResource.getMessage('edit_panel.actions.title'),
        }
    }

    afterRender() {
        const actions = this.params.actions
        this.buttonMenu = new DropdownActionMenu({actions}).init(this.find('.buttonMenu'))

        this.find('.actionButton').click(this.openDropdownMenu.bind(this))
    }

    openDropdownMenu() {
        this.buttonMenu.showAt(this.$el)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/action/ActionsMenuButtons.js